import PagesRouteLogic from "./components/PagesRouteLogic";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import initStore from "./store";
import { PersistGate } from "redux-persist/integration/react";
import CircularProgress from "@mui/material/CircularProgress";
import { ToastContainer, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
////////////////////////////////
export default function App() {
  const storeObj = initStore();
  return (
    <Provider store={storeObj.store}>
      <PersistGate loading={<CircularProgress />} persistor={storeObj.persistor}>
        <BrowserRouter>
          <PagesRouteLogic />
        </BrowserRouter>
        <ToastContainer
          position="bottom-right"
          autoClose={7000}
          hideProgressBar={true}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable={false}
          pauseOnHover={false}
          transition={Slide}
          limit={5}
          theme="colored"
          // toastClassName
          // bodyClassName
        />
      </PersistGate>
    </Provider>
  );
}
